import { InterfaceModelContent } from "@/components/interface/InterfaceModelContent";
import { PageTitle } from "@/components/ui/PageTitle";
import { toast } from "sonner";
import { useOwnerData } from "@/hooks/useOwnerData";
import { useInterfaceModel } from "@/hooks/useInterfaceModel";
import { ErrorState } from "./ErrorState";

interface ProductsProps {
  sampleData: any[];
  onUpdateStock: (newData: any[]) => void;
}

export const Products = ({ sampleData, onUpdateStock }: ProductsProps) => {
  const { data: ownerData, isLoading: ownerLoading } = useOwnerData();
  const { data: interfaceModel, isLoading } = useInterfaceModel(ownerData?.business_type_id);

  if (ownerLoading || isLoading) {
    return <div>Chargement...</div>;
  }

  if (!ownerData) {
    return <ErrorState message="Aucune donnée trouvée pour votre profil" />;
  }

  if (!ownerData.business_type_id) {
    return <ErrorState message="Aucun type d'entreprise associé à votre profil" />;
  }

  if (!interfaceModel) {
    return (
      <ErrorState 
        message={`Aucun modèle d'interface trouvé pour votre type d'entreprise (ID: ${ownerData.business_type_id})`} 
      />
    );
  }

  const handleSaleClick = (item: any, isCredit?: boolean) => {
    console.log("Sale clicked", { item, isCredit });
    toast.success("Vente enregistrée");
  };

  const handleRestock = (item: any) => {
    console.log("Restock clicked", item);
    toast.success("Stock mis à jour");
  };

  const handleLoss = (item: any) => {
    console.log("Loss clicked", item);
    toast.success("Perte enregistrée");
  };

  const handleDelete = (item: any) => {
    if (item.newData) {
      onUpdateStock(item.newData);
    } else {
      const newData = sampleData.filter(product => product.id !== item.id);
      onUpdateStock(newData);
    }
    toast.success("Action effectuée avec succès");
  };

  const handleReturn = (item: any) => {
    console.log("Return clicked", item);
    toast.success("Retour enregistré");
  };

  return (
    <div className="space-y-8">
      <PageTitle
        title="Gestion des produits"
        subtitle="Gérez votre inventaire"
      />
      
      <InterfaceModelContent
        interfaceModel={interfaceModel}
        sampleData={sampleData}
        onSaleClick={handleSaleClick}
        onRestock={handleRestock}
        onLoss={handleLoss}
        onDelete={handleDelete}
        onReturn={handleReturn}
      />
    </div>
  );
};